export interface NWDEnvironment {
  AUTH_ENABLED: boolean;
  DOMAINS_API: string;
  DOMAINS_ENABLED: boolean;
  ENABLED_ROUTES: string;
  FILTER_ACTIVE_MESSAGES: boolean;
  NEWS_RSS_FEED_URL: string;
  NWD_API_BASE_URL: string;
  NWD_DASHBOARD_URL: string;
  NWD_NEWS_URL: string;
  SELFSERVICE_ENABLED: boolean;
  SENTRY_DSN: string;
  WIRELESS_ENABLED: boolean;
}

const defaults: NWDEnvironment = {
  AUTH_ENABLED: true,
  DOMAINS_API: "http://mockdomeinen",
  DOMAINS_ENABLED: true,
  ENABLED_ROUTES: "dashboard,news,domains",
  FILTER_ACTIVE_MESSAGES: false,
  NEWS_RSS_FEED_URL: "",
  NWD_API_BASE_URL: "http://mockApi/",
  NWD_DASHBOARD_URL: "",
  NWD_NEWS_URL: "",
  SELFSERVICE_ENABLED: false,
  SENTRY_DSN: "",
  WIRELESS_ENABLED: false,
};

let importedEnv: Env;
try {
  // when running the Angular app
  importedEnv = _NGX_ENV_;
} catch (_) {
  // in karma runner
  importedEnv = import.meta.env;
}

const buildEnvironment = (): NWDEnvironment => {
  if (!importedEnv) {
    // case for storybook, which doesn't have _NGX_ENV_ or import.meta.env
    return defaults;
  }

  return Object.keys(importedEnv)
    .filter((key) => key.startsWith("NWD_"))
    .reduce((acc, cur) => {
      const key = cur.replace(/^(NWD_)/, "");
      acc[key] = importedEnv[cur];
      return acc;
    }, defaults);
};

export const ENV: NWDEnvironment = buildEnvironment();

export const apiUrl = (path: string): string => ENV.NWD_API_BASE_URL + path;
